import React, { useEffect, useState } from "react";
import { LOCAL_IMAGE } from "../../../../../images/ImageConstant";
import { message, Select } from "antd";
import { Option } from "antd/es/mentions";
import useSelectedServerVersionStore from "../../../../../components/hooks/useSelectedServerVersionStore";
import { useParams } from "react-router-dom";
import { useProjectInfoStore } from "../../../../../zustand/store/projectInfoStore";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  downloadFinalModelCsv,
  listPatchVersion,
  upgradeServerVersion,
  viewModelOutputImage,
} from "../../../../../api/apiCallManager";
import { showError, showSuccess } from "../../../../../helpers/alerts";
import Loader from "../../../../../components/spinner/Loader";

function ModelResult({ selectedPatch, trainModelBtn }) {
  const [modelImage, setModelImage] = useState("");

  const {
    selectedServerVersionZustandState,
    setSelectedServerVersionZustandState,
  } = useSelectedServerVersionStore();
  const { id } = useParams();
  const { setProjectInfoZustandState, projectInfoZustandState } =
    useProjectInfoStore();

  // const upgradeModelMutation = useMutation({
  //   mutationFn: upgradeServerVersion,
  //   onSuccess: () => {
  //     showSuccess("Model upgraded successfully");
  //   },
  // });

  const viewImageMutation = useMutation({
    mutationFn: viewModelOutputImage,
    onSuccess: (response) => {
      if (response.statusCode == 200) {
        showSuccess("Image Generated");
        setModelImage(response);
      } else {
        // message.info("Not Found!");
        setModelImage("");
      }
    },
  });

  // const handleUpgrade = () => {
  //   if (!selectedPatch) {
  //     showError("Please select a patch version before upgrading");
  //     return;
  //   }

  //   const payload = {
  //     projectKey: projectInfoZustandState.project_key,
  //     patch_version: selectedPatch,
  //   };

  //   upgradeModelMutation.mutate(payload);
  // };

  useEffect(() => {
    if (selectedServerVersionZustandState) {
      const payload = {
        projectKey: projectInfoZustandState.project_key,
        patch_version: selectedPatch,
        project_id: id,
        patch_version: selectedPatch,
      };

      viewImageMutation.mutate(payload);
    }
  }, [selectedPatch, selectedServerVersionZustandState]);

  const downloadMutation = useMutation({
    mutationFn: downloadFinalModelCsv, // Replace with your actual download API call function
    onSuccess: (response) => {
      // Extract the headers and body from the response
      const { body, headers } = response;

      // Assuming body.url contains the direct URL to the ZIP file
      const zipFileUrl = body;

      // Trigger the download of the ZIP file
      const a = document.createElement("a");
      a.href = zipFileUrl;
      a.download = "model_output.zip"; // Optional: Specify the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      showSuccess("Downloading  Started Successfully");
    },
  });
  // Call the function with your binary data (the 'body' field)

  const handleDownload = () => {
    const payload = {
      projectKey: projectInfoZustandState.project_key,
      project_id: id,
      patch_version: selectedPatch,
    };

    downloadMutation.mutate(payload);
  };

  return (
    <div>
      {/* <button
        className="bg-green-400 py-1 text-[14px] rounded-sm px-4"
        onClick={handleUpgrade}
        disabled={upgradeModelMutation.isLoading}
      >
        Upgrade <Loader isLoading={upgradeModelMutation.isPending} />
      </button> */}
      <div className=" flex absolute left-[280px] top-0">
        {modelImage?.body?.image_base64 ? "" : trainModelBtn}
        {modelImage?.body?.image_base64 && (
          <button
            onClick={handleDownload}
            className="bg-blue-600 text-white py-1 text-[14px] rounded-sm px-4 mx-3"
          >
            Download <Loader isLoading={downloadMutation.isPending} />
          </button>
        )}
      </div>
      <div className="my-3"></div>
      {/* {JSON.stringify(modelImage)} */}
      {modelImage?.body?.image_base64 ? (
        <img
          src={`data:image/png;base64,` + modelImage?.body?.image_base64}
          className="h-[350px] w-[100%] object-contain"
        />
      ) : (
        <div className="bg-gray-100 p-3 text-center">No Data</div>
      )}
    </div>
  );
}

export default ModelResult;
